module.exports = "/_next/static/images/b96cd07f17d77aa5f1e78265513ce45f-phone-recharge-icon.svg.webp";